import dayjs from "dayjs";
import { THEME } from "./LookupConst";

const query = require("india-pincode-search");
// Local storage get set remove method
export const LocalStorage = {
  set: (key: string, object: any) => {
    try {
      window.localStorage.setItem(key, object);
    } catch (e) {
      console.error("Error setting data from localStorage", e);
    }
  },
  append: (key: string, value: any) => {
    const storageString: string = `SIPAbacus_${Product.ProductCode()}`;
    try {
      let item: any = window.localStorage.getItem(storageString);
      item || LocalStorage.set(storageString, "");
      item = JSON.parse(item) || {};
      item[key] = value;
      LocalStorage.set(storageString, JSON.stringify(item));
      window.dispatchEvent(new Event("storage"));
    } catch (e) {
      console.error("Error appending data from localStorage", e);
    }
  },
  get: (key: string) => {
    const storageString: string = `SIPAbacus_${Product.ProductCode()}`;
    try {
      let item: any = window.localStorage.getItem(storageString);
      item = JSON.parse(item);
      return item ? item[key] : undefined;
    } catch (e) {
      console.error("Error getting data from localStorage", e);
    }
  },
  remove: (key: any, logout?: boolean) => {
    const storageString: string = `SIPAbacus_${Product.ProductCode()}`;
    try {
      if (logout) {
        const rememberMeDetails = LocalStorage.get("rememberMeDetails");
        localStorage.removeItem(storageString);

        sessionStorage.removeItem("user-token");
        LocalStorage.append("rememberMeDetails", rememberMeDetails);
        return true;
      }
      let item: any = window.localStorage.getItem(storageString);
      item = JSON.parse(item);
      delete item[key];
      LocalStorage.set(storageString, JSON.stringify(item));
    } catch (e) {
      console.error("Error deleting data from localStorage", e);
    }
  },
};

export const CommonUtil = {
  appendQueryStr: (ids: number[], name: string) => {
    let queryStr = "";
    if (ids && ids.length) {
      for (let i = 0; i < ids.length; i++) {
        if (i === 0) {
          queryStr += `?${name}=${ids[i]}`;
        } else {
          queryStr += `&${name}=${ids[i]}`;
        }
      }
    }
    return queryStr;
  },
  getYearNo: (min: number = 2) => {
    return min;
  },
  getParam: (array: any) => {
    let param = "";
    array.forEach((pair: any) => {
      const [key, item] = Object.entries(pair)[0]; // Extract key-value pair
      if (item) {
        param += param ? `&${key}=${item}` : `${key}=${item}`;
      }
    });
    return param;
  },
  getStatus: (statusBoolean: any, view?: boolean) => {
    if (statusBoolean === true) {
      return "Yes";
    } else if (!statusBoolean) {
      return "No";
    } else if (statusBoolean === "Yes" && !view) {
      return true;
    } else if (statusBoolean === "Yes" && view) {
      return "Active";
    } else if (statusBoolean === "No" && view) {
      return "Inactive";
    } else {
      return false;
    }
  },
  pinCode: (value: any) => {
    let searchPinCode = query?.search(value);
    return searchPinCode ? searchPinCode[0] : "";
  },
  parseDate(dateString: string): any {
    const date = dayjs(dateString, "D/M/YYYY");
    if (date.isValid()) {
      return date.toDate();
    }
    return dayjs(0).toDate();
  },
  caseInsensitiveSort: (rowA: any, rowB: any) => {
    const a = rowA.toLowerCase();
    const b = rowB.toLowerCase();
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  },
  caseInsensitiveDateSort: (rowA: any, rowB: any) => {
    const a = rowA;
    const b = rowB;
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  },
  dateFormate: (value: any, formate?: any) => {
    if (formate) {
      return dayjs(value, formate).format("DD/MM/YYYY");
    } else {
      return dayjs(value).format("DD/MM/YYYY");
    }
  },
  download: (response: any, fileTypePDF?: boolean) => {
    const fileName = response.headers["content-disposition"]
      .split("filename=")[1]
      .replace(/['"]/g, "");
    const url = window.URL.createObjectURL(
      new Blob([response.data], {
        type: fileTypePDF ? "application/pdf" : "application/vnd.ms-excel",
      })
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  checkLengthHandler: (e: any, maxLength: number) => {
    e.target.value = Math.max(0, parseInt(e.target.value))
      .toString()
      .slice(0, maxLength);
  },
  accessCheckHandler: (module: string, screen: string) => {
    const moduleAccess = LocalStorage.get("menuAccess")?.menus?.find(
      (item: any) => item.menuName === module
    );
    const access = moduleAccess?.subMenu?.find(
      (menu: any) => menu.subMenuName === screen
    )?.access;
    return access;
  },
  loginTypeHandler: () => {
    return LocalStorage.get("loginType");
  },
  formateDropdownList: (data: any, key: string) => {
    const dropdownList: any = [];
    data?.forEach((item: any) => {
      dropdownList.push({ label: item[key], value: item.id });
    });
    return dropdownList;
  },
  formateDropdownListWithAllData: (data: any, key: string) => {
    data?.forEach((item: any) => {
      item["label"] = item[key];
      item["value"] = item.id;
    });
    return data;
  },
  copyObject: (data: any) => JSON.parse(JSON.stringify(data)),
  handleCopy: (text: any) => {
    var tempTextArea = document.createElement("textarea");

    // Set attributes and append to the DOM
    Object.assign(tempTextArea, {
      value: text,
      style: "position: absolute; left: -9999px;",
    });
    document.body.appendChild(tempTextArea);

    // Select the text within the textarea and execute copy command
    tempTextArea.select();
    document.execCommand("copy");

    // Remove the temporary textarea from the DOM
    document.body.removeChild(tempTextArea);
  },
  getItemNameById: (itemId: string, options: any[]) => {
    return options.find((item: any) => item.value === parseInt(itemId))?.label;
  },
  getItemIdByName: (itemName: string, options: any[]) => {
    return options.find((item: any) => item.label === itemName)?.value;
  },
  convertBlobToBase64: (blob: any) => {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  },
};

//Form valitation utils
export const FormValidation = {
  // Only Alpha numeric
  getIdPattern: () => {
    return /^[A-Za-z0-9]+$/;
  },
  alphaNumericWithSpacePattern: () => {
    return /^[-_ a-zA-Z0-9]+$/;
  },
  getNamePattern: () => {
    return /^[A-Za-z\s.]+$/;
  },
  getMobileNumberPattern: () => {
    return /^[6-9]\d{9}$/;
  },
  getEmailPattern: () => {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;
  },
  getNumberPatter: () => {
    return /[0-9]/;
  },
  getNumberWithDecimalPatter: () => {
    return /[0-9.]/;
  },
};

//Util for get user details
export const LoginUserDetails = {
  getUserDetails: () => {
    const UserDetails = () => LocalStorage.get("loginResponse");
    return UserDetails();
  },
  getCountry: () => {
    const userDetails = LoginUserDetails.getUserDetails();
    const lclCountryName = userDetails?.franchisee?.centerAddress?.country;
    return lclCountryName;
  },
};

export interface Access {
  create: boolean | string;
  update: boolean | string;
  view: boolean | string;
  delete: boolean | string;
}

export const Product = {
  ProductCode: () => {
    return process.env.REACT_APP_PRODUCT_CODE;
  },
  ColorCode: () => {
    if (process.env.REACT_APP_PRODUCT_CODE === THEME.GA) {
      return "#0095da";
    } else if (process.env.REACT_APP_PRODUCT_CODE === THEME.SA) {
      return "#f48220";
    } else {
      return "#e31e26";
    }
  },
};
